<template>
  <div class="circulation">
    <div class="title">加工信息</div>
    <div class="item-wrap">
      <div class="left" v-for="(item, index) in info" :key="index">
        <div :class="['tle', index === 0 ? 'first' : '']">{{ item.title }}</div>
        <div
          class="item"
          v-for="(item2, index2) in item.children"
          :key="index2"
        >
          <img v-show="item2.img" :src="item2.img" alt=""> 
          {{ item2.name }}<span>{{ item2.value }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: [
        {
          title: "领料出库",
          children: [
            { name: "负责人：", value: "王爱国" },
            { name: "地点：", value: "半成品仓库" },
          ],
        },
        {
          title: "茶叶分级筛选",
          children: [
            { img:require('@/assets/images/test/21.png') },
          ],
        },
        {
          title: "萎凋",
          children: [
             { img:require('@/assets/images/test/22.png') },
          ],
        },
        {
          title: "烘干",
          children: [
             { img:require('@/assets/images/test/23.png') },
          ],
        },
        {
          title: "拣剔",
          children: [
            { img:require('@/assets/images/test/24.png') },
          ],
        },{
          title: "包装",
          children: [
            { img:require('@/assets/images/test/25.png') },
          ],
        },{
          title: "成品入库",
          children: [
            { name: "负责人： ", value: "张小红" },
            { name: "地点：", value: "成品仓库" },
          ],
        },
      ],
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    try{
       this.$setApptitle('链白茶防伪溯源');
    }catch{
      console.log('not webview')
    }
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  //方法
  methods: {},
};
</script>
<style lang="scss" scoped>
.circulation {
  .item-wrap {
    .left {
      position: relative;
      margin-bottom: 32px;
      padding-left: 40px;
      border-left: 5px solid #26907a;
      &::before {
        content: "";
        position: absolute;
        top: 20px;
        left: -3px;
        transform: translateX(-50%);
        width: 28px;
        height: 28px;
        background: #ffffff;
        border: 5px solid #26907a;
        border-radius: 50%;
      }
      &:first-child::before {
        content: "";
        position: absolute;
        top: 0;
        left: -3px;
        transform: translateX(-50%);
        width: 28px;
        height: 28px;
        background: #ffffff;
        border: 5px solid #26907a;
        border-radius: 50%;
      }
      .tle {
        position: relative;
        top: 5px;
        padding: 14px 32px;
        box-sizing: border-box;
        text-align: center;
        display: inline-block;
        background-color: #26907a;
        font-size: 28px;
        color: #fff;
        border-radius: 16px;
        &::before {
          position: absolute;
          top: 50%;
          left: -12px;
          transform: translateY(-50%);
          content: "";
          width: 12px;
          height: 8px;
          background: #26907a;
        }
      }
      .first {
        top: -14px;
      }
      .item {
        margin-top: 20px;
        margin-bottom: 16px;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 38px;
        color: #222222;
        img {
          width: 470px;
          height: 264px;
        }
        span {
          font-size: 28px;
          color: #808080;
        }
      }
    }
  }
}
</style>
